<div class="caption-bar">
  <div class="caption">Willkommen {{ state.displayName }}!</div>
</div>
@if(state.modt){
<div class="stats" style="max-width: 550px; background-color: cornsilk">
  <div class="stats-caption">Neuigkeiten</div>
  <div style="padding: 12px 17px">{{ state.modt }}</div>
</div>
}

<div class="stats">
  <div class="stats-caption">Aktueller Status</div>
  <ion-list>
    <ion-item (click)="routerService.routeToConstructionDayReportOverview()">
      <ion-label>Offene Bautagesberichte</ion-label>
      <ion-badge [color]="openReportsBadgeColor$ | async">{{
        openReports$ | async
      }}</ion-badge>
    </ion-item>

    <!--ion-item (click)="routerService.routeToTripReportOverview()">
      <ion-label>Offene Fahrtenberichte</ion-label>
      <ion-badge [color]="openTripReportsBadgeColor$ | async">{{
        openTripReports$ | async
      }}</ion-badge>
    </ion-item-->

    <ion-item (click)="routerService.routeToAbsenceOverview()">
      <ion-label>Offene Abwesenheitsanträge</ion-label>
      <ion-badge [color]="openAbsenceEntriesBadgeColor$ | async">{{
        openAbsenceEntries$ | async
      }}</ion-badge>
    </ion-item>

    <ion-item (click)="routerService.routeToMachinery()">
      <ion-label>Offene Maschinenprüfungen</ion-label>
      <ion-badge [color]="openInspectionsBadgeColor$ | async">{{
        openInspections$ | async
      }}</ion-badge>
    </ion-item>
    @if(state.userHasMinType(1)){
    <ion-item (click)="routerService.routeToMachinery()">
      <ion-label>Maschinenprüfungen abgelaufen</ion-label>
      <ion-badge [color]="openMachinesBadgeColor$ | async">{{
        openMachines$ | async
      }}</ion-badge>
    </ion-item>
    <ion-item (click)="openMissingWorkEntriesPopup()">
      <ion-label>Fehlende Arbeitszeiten</ion-label>
      <ion-badge [color]="missingWorkEntriesColor$ | async">{{
        missingWorkEntries$ | async
      }}</ion-badge>
    </ion-item>
    }
  </ion-list>
</div>
